import { render, staticRenderFns } from "./SuspendedEmployeesTable.vue?vue&type=template&id=7ff9a11e&scoped=true"
import script from "./SuspendedEmployeesTable.vue?vue&type=script&lang=js"
export * from "./SuspendedEmployeesTable.vue?vue&type=script&lang=js"
import style0 from "./SuspendedEmployeesTable.vue?vue&type=style&index=0&id=7ff9a11e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff9a11e",
  null
  
)

export default component.exports